import {
  Component,
  inject,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { OrganizationComponent } from "@components/organization/organization.component";
import { MatStepper, MatStepperModule } from "@angular/material/stepper";
import { OrganizationEMRFormComponent } from "../organization-emr-form/organization-emr-form.component";
import { MatButtonModule } from "@angular/material/button";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { Store } from "@ngrx/store";
import { AddOrganizationActions } from "@store/actions/add-organization/add-organization.actions";
import { MatIconModule } from "@angular/material/icon";
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { ClinicianDetailsComponent } from "../clinician-details/clinician-details.component";
import { AgreementTableComponent } from "@components/agreement-table/agreement-table.component";
import { QualityMeasureSelectionSurveyComponent } from "@components/quality-measure-selection-survey/quality-measure-selection-survey.component";
import { UserService } from "@services/user.service";
import { ROLE_GROUPS } from "@constants/roles";


@Component({
  selector: "app-stepper",
  imports: [
    OrganizationComponent,
    MatStepperModule,
    FormsModule,
    ReactiveFormsModule,
    OrganizationEMRFormComponent,
    MatButtonModule,
    MatIconModule,
    ClinicianDetailsComponent,
    AgreementTableComponent,
    QualityMeasureSelectionSurveyComponent,
  ],
  templateUrl: "./stepper.component.html",
  styleUrl: "./stepper.component.css",
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
  encapsulation: ViewEncapsulation.None,
})
export class StepperComponent implements OnInit {
  private readonly formBuilder = inject(FormBuilder);
  private readonly store = inject(Store);
  private readonly userService = inject(UserService);

  isMeasureSurveyStepVisible = toSignal(
    this.userService.hasRequiredRoles(ROLE_GROUPS.SUPER_USER),
    { initialValue: false }
  );

  orgInfo!: FormGroup;
  emrInfo!: FormGroup;
  thirdFormGroup!: FormGroup;

  @ViewChild("stepper") stepper!: MatStepper;

  ngOnInit() {
    this.orgInfo = this.formBuilder.group({});
    this.emrInfo = this.formBuilder.group({});
    this.thirdFormGroup = this.formBuilder.group({});
  }

  completeStepOne() {
    if (this.orgInfo.valid) {
      this.store.dispatch(AddOrganizationActions.saveButtonPressed());
    }
  }


}
